/**
 * Auto-registers every raster/SVG under `src/assets/images`.
 * Use `imageName="basename"` (no extension), e.g. `image_02` for `image_02.jpg`.
 * Optional mobile asset: `{basename}_m` (e.g. `uud_2_m.png` for `imageName="uud_2"`).
 */
const campImageContext = require.context(
  "../../assets/images",
  false,
  /\.(png|jpe?g|webp|gif|svg)$/i,
);

/** @type {Record<string, string>} basename (no ext) → bundled URL */
export const CAMP_IMAGES = campImageContext.keys().reduce((acc, filePath) => {
  const fileName = filePath.replace(/^\.\//, "");
  const baseKey = fileName.replace(/\.(png|jpe?g|webp|gif|svg)$/i, "");
  acc[baseKey] = campImageContext(filePath);
  return acc;
}, {});

/** @param {string | null | undefined} name @returns {string | null} */
function campImageBaseKey(name) {
  if (name == null || String(name).trim() === "") return null;
  const trimmed = String(name).trim();
  return trimmed.replace(/\.(png|jpe?g|webp|gif|svg)$/i, "");
}

/**
 * @param {string | null | undefined} name
 * @returns {string | undefined} Bundled asset URL, or undefined if no `_m` entry.
 */
export function resolveCampMobileImage(name) {
  const base = campImageBaseKey(name);
  if (base == null) return undefined;
  const mobileKey = `${base}_m`;
  return CAMP_IMAGES[mobileKey];
}

/**
 * @param {string | null | undefined} name
 * @returns {string | undefined} Bundled asset URL, or undefined if unknown / empty.
 */
export function resolveCampImage(name) {
  if (name == null || String(name).trim() === "") return undefined;
  const base = campImageBaseKey(name);
  if (base && CAMP_IMAGES[base]) return CAMP_IMAGES[base];
  const trimmed = String(name).trim();
  if (CAMP_IMAGES[trimmed]) return CAMP_IMAGES[trimmed];
  if (process.env.NODE_ENV === "development") {
    console.warn(
      `[camp] Unknown imageName "${name}". Add a file to src/assets/images (e.g. ${base || "my_image"}.png).`,
    );
  }
  return undefined;
}
